import { v4 as uuidv4 } from "uuid";

const combineDateAndTime = (date, time) => {
    const combinedDateTime = new Date(date);
    const [hours, minutes] = time.split(":");
    combinedDateTime.setHours(Number(hours));
    combinedDateTime.setMinutes(Number(minutes));
    combinedDateTime.setSeconds(0);
    combinedDateTime.setMilliseconds(0);
    return combinedDateTime;
};

// ✅ tambah nota & kitabId di hujung (optional)
const getRepeatedEvents = (
    frequency,
    selectedDate,
    startTime,
    eventTitle,
    speakerName,
    speakerImage,
    posterImage,
    speakerPosition,
    subjek,
    tajuk,
    repeatEndDate,
    isKuliah,
    isPosterToEtv,
    nota = "",
    kitabId = null
) => {
    console.log("trigger getRepeatedEvents");

    const events = [];
    const selectedTimestamp = selectedDate.getTime();
    const repeatEndTimestamp = repeatEndDate.getTime();

    // weekly = 7 hari, monthly = loop daily (filter minggu/day)
    const interval =
        frequency === "weekly" ? 7 * 24 * 60 * 60 * 1000 : 24 * 60 * 60 * 1000;

    for (let timestamp = selectedTimestamp; timestamp <= repeatEndTimestamp; timestamp += interval) {
        const repeatedDate = new Date(timestamp);

        if (frequency === "monthly") {
            const selectedDay = selectedDate.getDay();
            const selectedWeekOfMonth = Math.ceil(selectedDate.getDate() / 7);

            if (
                repeatedDate.getDay() !== selectedDay ||
                Math.ceil(repeatedDate.getDate() / 7) !== selectedWeekOfMonth
            ) {
                continue;
            }
        }

        const startDateTime = combineDateAndTime(repeatedDate, startTime);

        const event = isKuliah
            ? {
                eventId: uuidv4(),
                title: eventTitle,
                speaker: speakerName,
                speakerImage,
                speakerPosition: speakerPosition || "Penceramah",
                start: startDateTime,
                allDay: false,
                isKuliah: true,

                // ✅ kekal untuk ETV lama
                subjek,
                tajuk,
                nota: nota || "",

                // ✅ untuk search/future
                kitabId: kitabId || null,

                time: startTime,

            }
            : {
                eventId: uuidv4(),
                title: eventTitle,
                posterImage,
                start: startDateTime,
                allDay: false,
                isKuliah: false,
                isPosterToEtv: !!isPosterToEtv,
                time: startTime,
            };

        events.push(event);
    }

    return events;
};

export { getRepeatedEvents };
